function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), React.createElement("g", {
  fill: "none"
}, React.createElement("path", {
  fill: "#9FCDFF",
  d: "M19 4H5L.1 13.5a12 12 0 0023.8 0L19 4z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M5 12v7.74c0 .5.23.97.64 1.26a11 11 0 0012.71 0c.42-.29.66-.76.65-1.26V12H5z"
}), React.createElement("path", {
  fill: "#556CD6",
  d: "M12 0A12 12 0 00.1 13.5h23.8A12 12 0 0012 0zm7 10.5H5V7c0-1.1.9-2 2-2h10a2 2 0 012 2v3.5z"
}))));